import {Component, Input, OnInit} from '@angular/core';
import {ReferenceBookType, RefundResponse} from '@npck/af-frontend-api';
import {mapToViewModel} from '../../../../components/files/file-preview/file-preview.component';
import {DictionaryHolderService} from '../../../../domain/dictionary-holder.service';
import {AttachmentViewModel} from '../../../incidents/details/documents-tab/documents-tab.component';

@Component({
    selector: 'af-refund-approval-tab',
    standalone: false,
    templateUrl: './refund-approval-tab.component.html',
})
export class RefundApprovalTabComponent implements OnInit {
    @Input() refund!: RefundResponse;
    attachments: AttachmentViewModel[] = [];

    constructor(private dictionaryHolderService: DictionaryHolderService) {
    }

    ngOnInit(): void {
        this.dictionaryHolderService.getReference(ReferenceBookType.ATTACHED_DOC)
            .subscribe(docTypes => {
                this.attachments = this.refund.attachments
                    .filter(attachment => attachment.docType === 'PROSECUTOR_ORDER')
                    .map(attachment => mapToViewModel(attachment, docTypes));
            });
    }
}
